import React from 'react';
import { Link } from 'react-router-dom';
//import "../static/css/Page404.css"

function Page404() {
    return(
        <div className='Page404_body'>
            <div class="error-404">
                <h2>Whooos!!!</h2>
                <div class="page-404">
                    <span>The page can not be found</span>
                </div>
                <p>We could not found the page you are looking for. Please try another page and verify the URL you have entered.</p>
                <Link to="/home" class="go-back">Go back to home page</Link>
            </div>      
        </div>
    );
}

export default Page404;